import { ABP, AuthGuard, PermissionGuard } from '@abp/ng.core';
import { SettingManagementConfigModule } from '@abp/ng.setting-management/config';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApplicationLayoutComponent } from '@volo/abp.ng.theme.lepton';
import { CustomAuthGuard } from './identity/guards/CustomAuth.Guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [CustomAuthGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
  },
  //  {
  //   path: '',
  //   pathMatch: 'full',
  //   loadChildren: () => import('./shared/notification-user/notification-user.module').then(m => m.NotificationUserModule),
  // },
  {
    path: 'account',
    canActivate: [CustomAuthGuard],
    loadChildren: () =>
      import('@volo/abp.ng.account/public').then(m => m.AccountPublicModule.forLazy()),
  },
  // {
  //   path: 'identity',
  //   loadChildren: () => import('@volo/abp.ng.identity').then(m => m.IdentityModule.forLazy()),
  // },
  {
    path: 'identity',
    canActivate: [CustomAuthGuard],
    loadChildren: () => import('./identity/identity.module').then(m => m.IdentityModule.forLazy()),
  },
  {
    path: 'setting-management',
    canActivate: [CustomAuthGuard],
    loadChildren: () =>
      import('@abp/ng.setting-management').then(m => m.SettingManagementModule.forLazy()),
  },
  {
    path: '',
    component: ApplicationLayoutComponent,
    loadChildren: () => import('./warr/warr.module').then(m => m.WarrModule),
    canActivate: [AuthGuard, PermissionGuard, CustomAuthGuard],
    data: {
      routes: {
        iconClass: 'fa fa-shield',
        name: 'WARR::Menu:WARR',
        requiredPolicy: 'WARR.AccessWeb',
        requiresLogin: true,
        children: [
          {
            path: 'warranty/search',
            name: 'WARR::Menu:WarrInformationManagement',
            requiresLogin: true,
            requiredPolicy: 'WARR.Warranties',
          },
          {
            path: 'warranty/create',
            name: 'WARR::Menu:WarrantyCreated',
            requiresLogin: true,
            requiredPolicy: 'WARR.Warranties.Create',
          },
          {
            path: 'warranty/assign',
            name: 'WARR::Menu:AssignServiceCenters',
            requiredPolicy: 'WARR.AssignSC',
            requiresLogin: true,
          },
          {
            path: 'warranty/cost',
            name: 'WARR::Menu:Cost',
            requiresLogin: true,
            requiredPolicy: 'WARR.CostInformationManagements',
          },
          {
            path: 'warranty/complete',
            name: 'WARR::Menu:WarrCompleted',
            requiresLogin: true,
            requiredPolicy: 'WARR.Warranties.Actions.Completed',
          },
        ],
      },
    },
  },
  {
    path: '',
    component: ApplicationLayoutComponent,
    loadChildren: () => import('./warr/warr.module').then(m => m.WarrModule),
    canActivate: [AuthGuard, CustomAuthGuard],
    data: {
      routes: {
        iconClass: 'fa fa-warehouse',
        name: 'WARR::Menu:WarrServiceCenter',
        requiresLogin: true,
        requiredPolicy: 'WARR.ServiceCenterData',
        children: [
          {
            path: 'service-center/inventory-data',
            name: 'WARR::Menu:InventoryData',
            requiresLogin: true,
            requiredPolicy: 'WARR.ServiceCenterData.MenuInventory',
          },
          {
            path: 'service-center/import-ticket',
            name: 'WARR::Menu:ImportTicket',
            requiresLogin: true,
            requiredPolicy: 'WARR.ServiceCenterData.MenuImportTicket',
          },
          {
            path: 'service-center/export-ticket',
            name: 'WARR::Menu:ExportTicket',
            requiresLogin: true,
            requiredPolicy: 'WARR.ServiceCenterData.MenuExportTicket',
          },
          {
            path: 'service-center/transfer-ticket',
            name: 'WARR::Menu:TransferTicket',
            requiresLogin: true,
            requiredPolicy: 'WARR.ServiceCenterData.MenuTransferTicket',
          }
        ],
      },
    },
  },
  {
    path: '',
    component: ApplicationLayoutComponent,
    loadChildren: () => import('./warr/warr.module').then(m => m.WarrModule),
    canActivate: [AuthGuard, CustomAuthGuard],
    data: {
      routes: {
        iconClass: 'fa fa-life-ring',
        name: 'WARR::Menu:WarrAccessoryRequest',
        requiredPolicy: 'WARR.AccessWeb',
        requiresLogin: true,
        children: [
          {
            path: 'accessory/search',
            name: 'WARR::Menu:SearchAccessoryRequest',
            requiresLogin: true,
            requiredPolicy: 'WARR.AccessoryRequest',
          },
          {
            path: 'accessory/quote',
            name: 'WARR::Menu:AccessoryQuote',
            requiresLogin: true,
            requiredPolicy: 'WARR.AccessoryQuote',
          },
          {
            path: 'accessory/receive',
            name: 'WARR::Menu:ReceiveAccessoryRequest',
            requiresLogin: true,
            requiredPolicy: 'WARR.AccessoryRequest.Receive',
          },
          {
            path: 'accessory/handover',
            name: 'WARR::Menu:HandOverAccessoryRequest',
            requiresLogin: true,
            requiredPolicy: 'WARR.AccessoryRequest.HandOver',
          },
          {
            path: 'accessory/proceed',
            name: 'WARR::Menu:ProcessAccessoryRequest',
            requiresLogin: true,
            requiredPolicy: 'WARR.AccessoryRequest.Process',
          },
          {
            path: 'accessory/received-serial',
            name: 'WARR::Menu:ReceivedSerial',
            requiresLogin: true,
            requiredPolicy: 'WARR.SerialManagement',
          },
        ],
      },
    },
  },
  {
    path: '',
    component: ApplicationLayoutComponent,
    loadChildren: () => import('./warr/warr.module').then(m => m.WarrModule),
    canActivate: [AuthGuard, CustomAuthGuard],
    data: {
      routes: {
        iconClass: 'fa fa-life-ring',
        name: 'WARR::Menu:WarrAccessoryRecall',
        requiresLogin: true,
        children: [
          {
            path: 'accessory-recall/proceed',
            name: 'WARR::Menu:ProcessAccessoryRecall',
            requiresLogin: true,
            requiredPolicy: 'WARR.AccessoryRecall.Process',
          },
          {
            path: 'accessory-recall/disposed',
            name: 'WARR::Menu:DisposedAccessoryRecall',
            requiresLogin: true,
            requiredPolicy: 'WARR.AccessoryRecall.Dispose',
          },
        ],
      },
    },
  },

  {
    path: '',
    component: ApplicationLayoutComponent,
    loadChildren: () => import('./warr/warr.module').then(m => m.WarrModule),
    canActivate: [AuthGuard, CustomAuthGuard],
    data: {
      routes: {
        iconClass: 'fa fa-life-ring',
        name: 'WARR::Menu:WarrCategory',
        requiresLogin: true,
        children: [
          {
            path: 'category/service-center',
            name: 'WARR::Menu:ServiceCenter',
            requiresLogin: true,
            requiredPolicy: 'WARR.ServiceCenters',
          },
          // {
          //   path: 'category/error-and-solution',
          //   name: 'WARR::Menu:CommonList',
          //   requiresLogin: true,
          //   requiredPolicy: 'WARR.ErrorAndSolutions',
          // },
          {
            path: 'category/working-time',
            name: 'WARR::Menu:WorkingTimeConfigurations',
            requiresLogin: true,
            requiredPolicy: 'WARR.WorkingTimeConfigurations',
          },
        ],
      },
    },
  },

  {
    path: '',
    component: ApplicationLayoutComponent,
    loadChildren: () => import('./warr/warr.module').then(m => m.WarrModule),
    canActivate: [AuthGuard, PermissionGuard, CustomAuthGuard],
    data: {
      routes: {
        iconClass: 'fa fa-user-cog',
        name: 'WARR::Menu:WarrConfiguration',
        requiredPolicy: 'WARR.AccessWeb',
        requiresLogin: true,
        children: [
          {
            path: 'configuration/term-definition',
            name: 'WARR::Menu:WarrTermDefinition',
            requiresLogin: true,
            requiredPolicy: 'WARR.WarrTermDefinition',
          },
          {
            path: 'configuration/cost-config',
            name: 'WARR::Menu:CostConfigurations',
            requiresLogin: true,
            requiredPolicy: 'WARR.CostConfigurations',
          },
          {
            path: 'configuration/bom-version',
            name: 'Bom version',
            requiresLogin: true,
            requiredPolicy: 'WARR.BomVersion',
          },
          {
            path: 'configuration/distance',
            name: 'Khoảng cách',
            requiresLogin: true,
            requiredPolicy: 'WARR.Distance',
          },
          {
            path: 'configuration/costtype-config',
            name: 'Cấu hình loại chi phí',
            requiresLogin: true,
            requiredPolicy: 'WARR.CostTypeConfiguration',
          },
        ],
      },
    },
  },

  {
    path: '',
    component: ApplicationLayoutComponent,
    loadChildren: () => import('./warr/warr.module').then(m => m.WarrModule),
    canActivate: [AuthGuard, PermissionGuard, CustomAuthGuard],
    data: {
      routes: {
        iconClass: 'fa fa-user-cog',
        name: 'WARR::Menu:WarrEmployee',
        requiredPolicy: 'WARR.AccessWeb',
        requiresLogin: true,
        children: [
          {
            path: 'employee/list',
            name: 'WARR::Menu:Employee',
            requiresLogin: true,
            requiredPolicy: 'HR.Employees',
          },
          {
            path: 'identity',
            name: 'WARR::Menu:Role',
            requiresLogin: true,
            requiredPolicy: 'AbpIdentity.Roles',
          },
        ],
      },
    },
  },
  {
    path: '',
    component: ApplicationLayoutComponent,
    loadChildren: () => import('./warr/warr.module').then(m => m.WarrModule),
    canActivate: [AuthGuard, PermissionGuard, CustomAuthGuard],
    data: {
      routes: {
        iconClass: 'fa fa-flag',
        name: 'WARR::Menu:WarrReport',
        requiredPolicy: 'WARR.AccessWeb',
        requiresLogin: true,
        children: [
          // {
          //   path: 'reports/dashboard/manager',
          //   name: 'WARR::Menu:WarrReportDashboardManager',
          //   requiresLogin: true,
          //   requiredPolicy: 'WARR.WarrReport.WarrReportDashboardManager',
          // },
          // {
          //   path: 'reports/dashboard/casper-center',
          //   name: 'WARR::Menu:WarrReportDashboardCasperCenter',
          //   requiresLogin: true,
          //   requiredPolicy: 'WARR.WarrReport.WarrReportDashboardCasperCenter',
          // },
          // {
          //   path: 'reports/dashboard/service-center',
          //   name: 'WARR::Menu:WarrReportDashboardServiceCenter',
          //   requiresLogin: true,
          //   requiredPolicy: 'WARR.WarrReport.WarrReportDashboardServiceCenter',
          // },
          {
            path: 'reports/tickets',
            name: 'WARR::Menu:WarrReportWarrantyTicket',
            requiresLogin: true,
            requiredPolicy: 'WARR.WarrReport.WarrReportWarrantyTicket',
          },
          {
            path: 'reports/requests',
            name: 'WARR::Menu:WarrReportAccessoryRequest',
            requiresLogin: true,
            requiredPolicy: 'WARR.WarrReport.WarrReportAccessoryRequest',
          },
          {
            path: 'reports/costs',
            name: 'WARR::Menu:WarrReportWarrantyStationCost',
            requiresLogin: true,
            requiredPolicy: 'WARR.WarrReport.WarrReportWarrantyStationCost',
          },
          {
            path: 'reports/center-kpi',
            name: 'WARR::Menu:WarrReportWarrantyStationKpi',
            requiresLogin: true,
            requiredPolicy: 'WARR.WarrReport.WarrReportWarrantyStationKpi',
          },
          {
            path: 'reports/center-quality',
            name: 'WARR::Menu:WarrReportWarrantyQuality',
            requiresLogin: true,
            requiredPolicy: 'WARR.WarrReport.WarrReportWarrantyQuality',
          },
          {
            path: 'reports/inventory',
            name: 'WARR::Menu:WarrReportActualInventory',
            requiresLogin: true,
            requiredPolicy: 'WARR.WarrReport.WarrReportActualInventory',
          },
          {
            path: 'reports/trend',
            name: 'WARR::Menu:WarrReportWarrantyTrend',
            requiresLogin: true,
            requiredPolicy: 'WARR.WarrReport.WarrReportWarrantyTrend',
          },
          {
            path: 'reports/ticket-unprocessed',
            name: 'WARR::Menu:WarrReportNoProcess',
            requiresLogin: true,
            requiredPolicy: 'WARR.WarrReport.WarrReportNoProcess',
          },
          {
            path: 'reports/tracking-time',
            name: 'Thống kê thời gian bảo hành',
            requiresLogin: true,
            requiredPolicy: 'WARR.WarrReport.WarrReportTrackingTime',
          },
          {
            path: 'reports/import-ticket-detail',
            name: 'Báo cáo chi tiết phiếu nhập',
            requiresLogin: true,
            requiredPolicy: 'WARR.WarrReport.WarrReportImportTicketDetail',
          },
          {
            path: 'reports/export-ticket-detail',
            name: 'Báo cáo chi tiết phiếu xuất',
            requiresLogin: true,
            requiredPolicy: 'WARR.WarrReport.WarrReportExportTicketDetail',
          },
          {
            path: 'reports/import-export-inventory',
            name: 'Báo cáo xuất nhập tồn kho tại Trạm',
            requiresLogin: true,
            requiredPolicy: 'WARR.WarrReport.WarrReportExportImportInventory',
          },
          {
            path: 'reports/scope-operation',
            name: 'Báo cáo phạm vi hoạt động Trạm BH',
            requiresLogin: true,
            requiredPolicy: 'WARR.WarrReport.WarrReportScopeOperation',
          },
        ],
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
